/**
 * Feature flags service for managing UI feature visibility
 */

// Parse boolean environment variables
const parseBoolean = (value) => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }
  return false
}

// Feature flags configuration
const featureFlags = {
  ringbaIntegration: parseBoolean(process.env.VUE_APP_RINGBA_INTEGRATION_ENABLED)
}

/**
 * Check if a feature is enabled
 * @param {string} featureName - The name of the feature to check
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName) => {
  return featureFlags[featureName] || false
}

// Export specific feature flags for convenience
export const isRingbaIntegrationEnabled = () => isFeatureEnabled('ringbaIntegration')

// Export all flags (useful for debugging)
export const getAllFeatureFlags = () => ({ ...featureFlags })